<template>
    <v-app v-if="params_ok" id="app" :dark="false">
        <NotificationCenter />
        <GenericInputDialogFromAction />
        <OkCancelDialogFromAction />
        <ProgressComponent />
        <ButtonSelectionDialogFromAction />
        <EditHeader class="titlebar" />
        <TableEditor class="editor"
                     v-if="dataAvailable"
                     id="tableEditor"
                     v-on:currentScrollPosition="currentScrollPositionChange"
                     :initialScrollPosition="tableScrollPosition" />
        <div v-else class="editor"></div>
        <SettingsEditor />
        <InfoComponent />
        <EditFooter class="footer" />
    </v-app>
    <v-app v-else>
        Parameters missing
    </v-app>
</template>

<script>
    import EditHeader from "./EditHeader.vue";
    import EditFooter from "./EditFooter.vue";
    import TableEditor from "./TableEditor/TableEditor.vue";
    import SettingsEditor from "./SettingsEditor.vue";
    import NotificationCenter from "./NotificationCenter.vue";
    import OkCancelDialogFromAction from "./helpers/OkCancelDialogFromAction.vue";
    import GenericInputDialogFromAction from "./helpers/GenericInputDialogFromAction.vue";
    import ButtonSelectionDialogFromAction from "./helpers/ButtonSelectionDialogFromAction.vue";
    import ProgressComponent from "./helpers/ProgressComponent.vue";
    import InfoComponent from "./InfoComponent.vue";
    import { notificationMixin } from "../mixins/notificationMixin.js";
    import { LOAD_FILE } from "../../store/modules/uptData/constants.js";
    import { SET_REDIRECT_AFTER_SAVE } from "../../store/modules/settings/constants.js";
    import eventBus from "../utils/eventBus";

    const _ = require("lodash");

    export default {
        name: "FileEdit",
        mixins: [notificationMixin],

        data: () => ({
            needUpdate: false,
            tableScrollPosition: null,
            params_ok: false,
            params: null
        }),

        components: {
            EditHeader,
            EditFooter,
            TableEditor,
            SettingsEditor,
            NotificationCenter,
            OkCancelDialogFromAction,
            GenericInputDialogFromAction,
            ButtonSelectionDialogFromAction,
            ProgressComponent,
            InfoComponent
        },

        computed: {
            dataAvailable() {
                return this.$store.state.uptData.dataAvailable && !this.needUpdate;
            },
        },

        created: function () {
            this.params = {
                filepath: _.get(this.$route.query, "filepath", false),
                redirectUrl: _.get(this.$route.query, "redirect_url", false),
                callbackUrl: _.get(this.$route.query, "callback_url", false)
            }
            this.params_ok = this.params.filepath && this.params.redirectUrl;
            if (this.params_ok) {
                if (!this.params.filepath.toLowerCase().endsWith(".upt")) this.params.filepath += ".UPT";
                this.editSpecificFile();
            }
            eventBus.$on("fullUpdate", args => this.update(args));
        },

        beforeDestroy: function () {
            eventBus.$off("fullUpdate", args => this.update(args));
        },

        methods: {
            async editSpecificFile() {
                await this.$store.dispatch(SET_REDIRECT_AFTER_SAVE, {
                    filename: this.params.filepath,
                    customerId: null,
                    redirectUrl: this.params.redirectUrl,
                    callbackUrl: this.params.callbackUrl
                });
                this.$store.dispatch(LOAD_FILE, {
                    path: this.params.filepath,
                    specificCustomerId: null,
                });
            },
            update(args) {
                if (!_.get(args, "retainScrollPosition")) {
                    this.tableScrollPosition = 0;
                }
                this.needUpdate = true;
                this.$nextTick(() => (this.needUpdate = false));
            },
            currentScrollPositionChange(pos) {
                this.tableScrollPosition = pos;
            }
        },
    }
</script>
